import { render, staticRenderFns } from "./PopupLayout.vue?vue&type=template&id=069eaf76&scoped=true"
import script from "./PopupLayout.ts?vue&type=script&lang=ts&external"
export * from "./PopupLayout.ts?vue&type=script&lang=ts&external"
import style0 from "./PopupLayout.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./PopupLayout.vue?vue&type=style&index=1&id=069eaf76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069eaf76",
  null
  
)

export default component.exports